import { FetchStatus, IEntity, IMultipleEntities } from "../types";
import { useCallback, useEffect, useState } from "react";
import { useDataContext, usePageContext } from "../../design/page/context";

import { Binding } from "../bindings";
import Logger from "../../../helpers/Logger";
import { getProperties } from "./properties";
import { useFormDataContext } from "../../design/components/forms";

export const useGetProperties = ({ bindings }: {
    bindings: Binding[]
}) => {
    const [properties, setProperties] = useState<IEntity>({});
    const { type, result: data, status } = useDataContext()
    const { page, pageView } = usePageContext()
    const { values: formValues } = useFormDataContext()

    useEffect(() => {
        Logger.info(`page: ${page?.name}, sourceObject: ${page?.sourceObject}, type: ${type}, status: ${status}`)

        if (!page || !bindings || (page?.sourceObject && status !== FetchStatus.Success))
            return;

        try {
            const row = { ...getRecord(type, data), ...formValues };
            const filters = [...(pageView?.linkFilters || []), ...(pageView?.viewFilters || [])];
            const props = getProperties({ bindings, row, filters });
            setProperties(props);
        } catch (err) {
            Logger.error('get-properties', err)
        }
        // eslint-disable-next-line
    }, [status, bindings, pageView, formValues])

    const getBinding = useCallback((propId: string) => {
        return bindings?.find(p => p.propId === propId)
    }, [bindings])

    const getPropertyValue = <T>(propertyId: string) => {
        return bindings.find(p => p.propId === propertyId)?.value as (T | undefined);
    }

    return { properties, getBinding, getPropertyValue }
}

const getRecord = (type: string, data?: IEntity | IMultipleEntities) => {
    if (!data)
        return {};

    switch (type) {
        case "List":
            return data.records.length > 0 ? data.records[0] : {};
        case "Card":
            return data;
        case "Static":
            return {};
    }

    return {};
}